import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
`;
